import { Link } from "react-router-dom";
import { ReactComponent as GroceryEmptyIllustration } from "../../../media/grocery_empty.svg";
import TopNavbar from "../../../components/TopNavbar";
import Navbar from "../../../components/Navbar";
import GoToTop from "../../../components/GoToTop";
import "../../../styles/Containers.css";

// One shared empty state for /grocery, used both when the visitor isn't
// logged in and when they're logged in but haven't built a list yet - same
// illustration, copy/CTA swapped per variant.
const COPY = {
  guest: {
    title: "لیست خریدت اینجا منتظرته",
    caption: "وارد حسابت شو تا از روی تقویمت، لیست خرید هوشمند بسازی.",
    ctaLabel: "ورود یا ثبت‌نام",
  },
  empty: {
    title: "هنوز لیست خریدی نساختی",
    caption: "از روی غذاهایی که توی تقویمت داری، یه لیست خرید هوشمند بساز.",
    ctaLabel: "+ اضافه کردن لیست خرید از تقویم",
  },
};

// keep a side gutter so the full-width button never touches the screen edges
const ctaStyle = { width: "calc(100% - 40px)", boxSizing: "border-box" };

function GroceryEmptyState({ variant, onCtaClick }) {
  const copy = COPY[variant] || COPY.empty;

  return (
    <div className="paddingButtom80 grey-background">
      <TopNavbar
        title="لیست خرید"
        rbuttonIcon={[""]}
        rbuttonHref={["null"]}
        rbackground={["bTransparent"]}
        lbuttonIcon={[""]}
        lbuttonHref={["null"]}
        lbackground={["bTransparent"]}
      />

      <div className="centerd centerAlign paddingTop10">
        <GroceryEmptyIllustration
          role="img"
          aria-label="سبد خرید خالی با یک جوانه سبز و یک لیست خالی کنارش"
        />
        <p className="heading-3 grey-1 marginTop5">{copy.title}</p>
        <p className="subject-2 yekan grey-2 marginTop1 marginBottom5 paddingSide10">
          {copy.caption}
        </p>

        {variant === "guest" ? (
          <Link to="/login" className="primaryPurple" style={ctaStyle}>
            {copy.ctaLabel}
          </Link>
        ) : (
          <button type="button" onClick={onCtaClick} className="primaryPurple" style={ctaStyle}>
            {copy.ctaLabel}
          </button>
        )}
      </div>

      <Navbar />
      <GoToTop />
    </div>
  );
}

export default GroceryEmptyState;
